<template>

<v-dialog v-model="dialog" width="500px">
  <v-card>
    <p class=".title ma-2">Add a keyboxcode / Lock code to {{plsc.hspl_code }} </p>
    <v-form ref="addPlsc" v-model="addPlscValid">

     <v-row no-gutters>
        <v-col cols="6" class="mx-2">
            <v-menu
              v-model="plsc_datummenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
            <template v-slot:activator="{ on }">
            <v-text-field
              v-model="plsc_datum"
              label="Start date"   
              clearable
              :rules="plsc_datumRules"
              v-on="on"
            ></v-text-field>
            </template>
            <v-date-picker v-model="hulpDate" :first-day-of-week="1"  @input="plsc_datum = $moment(hulpDate).format('DD-MM-YYYY'); plsc_datummenu = false"></v-date-picker>
            </v-menu>  
          </v-col>
     </v-row>

     <v-row no-gutters>
        <v-text-field v-model="plsc_code" label="Keybox / Lock code" :rules="plsc_codeRules"></v-text-field>
     </v-row>      
    </v-form>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn class="primary mx-2" small @click="addPlsc" :disabled="!addPlscValid">Save</v-btn>
      <v-btn color="primary"  small @click="dialog = false">Close</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>
export default {
  data() { 
    return {
      dialog: false,
      addPlscValid: false,
      hspl_encrid: null,
      plsc_datum: '',
      hulpDate: '',
      plsc_datummenu: false,
      plsc_code: '',
      plsc: {},
      plsc_codeRules: [
          v => (v && v.length >= 3) || "A keybox / lock code is required"
      ],
      plsc_datumRules: [
          v => (v && v.length >= 6) || "A start date is required"
      ]
    }
  },
  methods: {
    open(hspl_encrid) {
      this.$emit("showSnackbar");
      this.dialog = true;
      this.$axios
        .post("ares/json/ares/huis/hspl/plsc/getHsplToAddPlsc.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getHsplToAddPlsc"
          },
          getHsplToAddPlsc: {
            hspl_encrid: hspl_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.plsc = res.data.getHsplToAddPlsc;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    addPlsc() { 
      this.$axios
        .post("ares/json/ares/huis/hspl/plsc/addPlsc.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "addPlsc"
          },
          addPlsc: {
            hspl_encrid: this.plsc.hspl_encrid,
            plsc_datum: this.plsc_datum,
            plsc_code: this.plsc_code
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else { 
             /*
             if (res.data.addPlsc.color == "success") { 
                setTimeout(() => { this.$router.reload('/hspl/onHspl/' + res.data.addPlsc.hspl_encrid);  }, 2000);      
             } 
             */        
             this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.addPlsc.text,
              color: res.data.addPlsc.color
            }); 
            this.dialog = false;
          }
        })
    },
  }
}
</script>

